import React from "react";
import styled from 'styled-components';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import ClaroImage from '../../../molecules/ClaroImage'
import { Link } from "react-router-dom";
import ClaroInputField from "../../../atoms/ClaroInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import { validationStyles } from '../utils/index'
import { getTagServiceId, getListFavsServices, getCanManageFavorites } from '../../../../store/selectors/paymentsSelectors';
import { getFavoritosRef, addFavoritesRef, deleteFavoritesRef } from '../../../../store/actions/favoritosRef';
import { executeTaggeo } from "../../../../store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateFavoriteService from "../../../molecules/createFavoriteService";

const Container = styled.div`
    width: 100%%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: ${props => props.margin ? props.margin : "2%"};
`;

export default class ContactInputClaroSocio extends React.Component {

    constructor(props, context){
        super(props, context);
        this.state = {
            isFocused: false,
            phoneNumber: undefined,
            alias: undefined,
            saveCard: false
        }
    }

    componentDidMount() {
        if(this.props.favoritos && !this.props.isContainerTelcel && this.props.canManageFavorites){
            this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
        }
    }

    componentDidUpdate(prevProps,prevState) {
        if(this.props.favoritos && !this.props.isContainerTelcel && this.props.canManageFavorites){
            if(!this.state.alias && this.state.phoneNumber && !this.state.saveCard && this.props.listFavServices !== undefined){
              this.handleAsignPhone();
            }
            if(this.props.inputValue && this.props.inputValue !== prevProps.inputValue){
                if(!this.props.listFavServices){
                    this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
                }
                this.handleValidateLength(this.props.inputValue,this.props.input);      
              }
              if(!this.props.inputValue && this.props.inputValue !== prevProps.inputValue){
                this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: this.props.inputValue}}, this.props.input.type);
                this.setState({ alias: undefined });   
                this.setState({ phoneNumber: undefined }); 
                if(!this.props.listFavServices){
                    this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
                }
              }
    
              if(this.props.hasFavsSuccess.alias && this.props.hasFavsSuccess.alias !== prevProps.hasFavsSuccess.alias){
                if(this.props.value === this.props.hasFavsSuccess.accountService){
                    this.setState({ alias: this.props.hasFavsSuccess.alias });
                }
            }
            }
    }

    handleImagenClick = () => {
        this.props.executeTaggeo({
            action: "Click Guardar Servicio",
            step: "Formulario de pago",
            service: this.props.tagServiceId,
        })
        this.setState({ saveCard: true });
    };

    handleCloseModal = (props) => {
        this.setState({ saveCard: false })
        this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
    }

    handleValidateLength = (e,input) =>{
        let inputNumber
        if(!this.props.inputValue){
          inputNumber = e.target.value
        }else{
            this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: this.props.inputValue}}, this.props.input.type);
            inputNumber = e;
        }
        const {isValid,isContainerTelcel,isClaroPartner,canManageFavorites,favoritos,serviceId,serviceInfo,tagServiceId} = this.props;
        const {phoneNumber,alias,saveCard,isFocused} = this.state;
        if(favoritos && !isContainerTelcel && canManageFavorites && !this.props.isClaroPartner){
                if (e.length >= input.field.input.truncateValue) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }   
        }
    }

    handleAsignPhone = () =>{
        const foundService = this.props.listFavServices.find(service => {
            return service.accountService === this.state.phoneNumber;
        })
        if (foundService) {
            const foundValue = foundService["alias"];
            this.setState({ alias: foundValue });
        }
    }

    render(){
        const {phoneNumber,alias,saveCard} = this.state;
        let { 
            input :{ id, field: {input, button}, title, type, subTitle}, 
            serviceName, 
            isValid, 
            canManageFavorites,
            favoritos,
            setDefaultValue, 
            handleInputChange,
            constraints,
            handleClickTooltip,
            handleInputButtonFunction,
            serviceId,
            isClaroPartner,
            isContainerTelcel,
            serviceTA
        } = this.props

        if (isContainerTelcel && !isClaroPartner) {
            button = {
                ...button,
                src: '/images/icono_agenda.png',
                width: '22.6',
                height: '27'
            }
        }

        let validation = validationStyles(isValid, isContainerTelcel, isClaroPartner);
        let value = (this.props.setDefaultValue) ? input.value : this.props.inputValue;
        const styles = {
            "color": validation.validInvalidColor,
            "borderBottom": isContainerTelcel && !isClaroPartner && this.state.isFocused && isValid && !serviceTA
                ? "1px solid #0071d1" 
                : validation.borderValidInvalidColor,
        }

        return(
            <Container
                background={isContainerTelcel && !isClaroPartner ? "#fff" : undefined}
                margin={isContainerTelcel && !isClaroPartner ? "2% 2% 15px 2%" : undefined}>
                <InputTitleClaroSocio 
                    {...title} 
                    type={type} 
                    handleClickTooltip={handleClickTooltip} 
                    isContainerTelcel={this.props.isContainerTelcel}
                    isFocused={this.state.isFocused}
                    serviceTA={serviceTA} />
                <ClaroDiv  {...styles}>
                    <ClaroInputField 
                        {...styles} 
                        constraints={constraints} 
                        value={value} 
                        onChange={(e) =>{
                            handleInputChange(e, type)
                            if(!this.props.inputValue){
                                this.handleValidateLength(e,this.props.input);
                            } 
                        }}
                        name={input.name}
                        placeholder={isClaroPartner && input.placeholderClaroSocio ?input.placeholderClaroSocio:input.placeholder}
                        id = {"pagoDeServicios_" + id + "_" + serviceName}
                        readOnly={input.disabled}
                        type={isClaroPartner && input.typeClaroSocio ? input.typeClaroSocio: input.type}
                        pattern="\d*"
                        //onInput={ (event) => {event.target.value = event.target.value.replace(/[^0-9]*/g,'')}}
                        phColor= {isContainerTelcel && !isClaroPartner ? "#757575" : "#c4c4c4"}
                        fontFamily = {isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                        fontSize = {isContainerTelcel && !isClaroPartner ? "14px" : undefined}
                        onFocus={()=>{this.setState({isFocused: true})}}
                        onBlur={()=>this.setState({isFocused: false})}
                    />
                    {this.state.phoneNumber && (

<>
    {alias && (
        <p style={{ position: 'absolute', fontSize:'13px', right: '20px', top: '0%', color:'#a6ce4e', transform: 'translateY(-50%)' }}>
           <span style={{ fontWeight: 'bold' }}>{alias}</span>
        </p>
    )}


    {!alias && (
       <p
       style={{
           position: 'absolute',
           right: '16px',
           fontSize:'14px',
           top: '10%',
           padding: '1px',
           transform: 'translateY(-50%)',
           color: '#329ebc', 
           fontWeight: 'bold', 
           textDecoration: 'underline', 
       }}
       onClick={this.handleImagenClick} 
   >
       Guardar Servicio 
   </p>
    )}
</>
)}
                    {
                      button && (!favoritos || !canManageFavorites) || (isContainerTelcel) ? (
                            <ClaroInputButton 
                                borderBottom={styles.borderBottom}
                                {...button}
                                onClick= {(e) =>{handleInputButtonFunction(e, type)}}
                            >
                                <Link 
                                    to={{
                                        pathname: '/contacts',
                                        state: {serviceId: serviceId, isContainerTelcel: isContainerTelcel, isClaroPartner: isClaroPartner}
                                    }}
                                >
                                    <ClaroImage {...button} isClaroPartner={isClaroPartner}  />
                                </Link>
                            </ClaroInputButton>
                        ):(<></>)
                    }
                </ClaroDiv>
                <InputSubTitleClaroSocio {...subTitle} type={type} />
                {saveCard && (
                    <CreateFavoriteService
                        isFavoriteServices={true}
                        accountService={phoneNumber}
                        isContainerTelcel={isContainerTelcel}
                        closeModalFavoriteServices={this.handleCloseModal}
                        hasFavs={true}
                    />
                )}
            </Container>
        )
    }
}

function mapStateToProps(state) {
    const { payments, favoritesRefReducer } = state;
    const tagServiceId = getTagServiceId(payments);
    const listFavServices = getListFavsServices(favoritesRefReducer)
    return {
        favoriteServices: state,
        tagServiceId,
        listFavServices,
        hasFavsSuccess: state.favoritesRefReducer.ResponseSuccess,
        isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
        canManageFavorites: payments.canManageFavorites,
        payments:payments
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getFavoritosRef,
            deleteFavoritesRef,
            executeTaggeo
        },
        dispatch
    );
}

ContactInputClaroSocio = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactInputClaroSocio);